
.modal {
  width: 31rem;
}

.modalContentContainer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1.5rem;
}

.titleText {
  color: var(--static-text-standard);
  font-size: var(--fs-small-heading);
}

.description {
  color: var(--static-text-standard);
}

.subDescription {
  color: var(--static-text-standard);
}

.linkContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem;
  gap: 0.75rem;
  border: 1px solid var(--static-divider-standard);
  border-radius: 8px;
  width: 100%;
}

.linkText {
  color: var(--static-text-standard);
  font-size: var(--fs-small-heading);
}

.switchContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}